export default {
	inProcessDev: `Pagina este în construcție! <br/> În curând îi veți putea folosi toate funcțiile. <br/> <strong> Vă mulțumim pentru înțelegere </strong>`,
}